var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',{attrs:{"align":"fixed"}},[_c('vs-tab',{attrs:{"label":"Reporte Tareas"}},[_c('div',{staticClass:"con-tab-ejemplo"},[_c('ReporteTareasVue')],1)]),_c('vs-tab',{attrs:{"label":"Historico actividades"}},[_c('div',{staticClass:"con-tab-ejemplo"},[_c('historicoActividadesVue')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }